"use client";
import dynamic from "next/dynamic";
const TopFaqsComponentClient = dynamic(() => import("./top-faqs-component-client"), { ssr: false });
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";

const TopFaqsLoader = ({
    res,
    loc,
    pathName,
}: {
    res: any;
    loc: string;
    pathName: string;
}) => {
    const { hasMouseMoved } = useMouseMovement();

    return hasMouseMoved ? (
        <TopFaqsComponentClient faqs={res} loc={loc} pathName={pathName} />
    ) : (
        <>
            {res.menuList?.map((faq: any, index: number) => (
                <>
                    {faq.attributes.displayName}
                    {faq.faqItems.map((item: any) => (
                        <>
                            {item.attributes.displayName}
                            {item.attributes.description}
                        </>
                    ))}
                </>
            ))}
            ;
        </>
    );
};

export default TopFaqsLoader;
